/**
 * GLTFMeshSocket defines a named attachment point on a GLTF model.
 * Sockets are used to attach components or other actors to specific bones.
 */
import * as THREE from 'three';

import { ClassRegistry, EngineClass } from '../../systems/ClassRegistry.js';
import { property } from '../../utils/serialization/decorator.js';

@EngineClass('MeshSocket')
export class MeshSocket {
  @property()
  public name: string = '';

  @property({
    type: 'enum',
    selector: 'getAvailableBones'
  })
  public boneName: string = '';

  @property()
  public offsetLocation: THREE.Vector3 = new THREE.Vector3(0, 0, 0);

  @property()
  public offsetRotation: THREE.Euler = new THREE.Euler();

  @property({
    type: 'vector3',
    initialValue: { x: 1, y: 1, z: 1 }
  })
  public offsetScale: THREE.Vector3 = new THREE.Vector3(1, 1, 1);
}

ClassRegistry.addClassesToRedirect({
  'ENGINE.GLTFMeshSocket': 'ENGINE.MeshSocket',
});

/**
 * @deprecated Use {@link MeshSocket} instead.
 */
export const GLTFMeshSocket = MeshSocket;

/**
 * @deprecated Use {@link MeshSocket} instead.
 */
export type GLTFMeshSocket = MeshSocket;
